<script>
import {useProductStore} from "@js/store/ProductStore.js";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import {Link} from "@inertiajs/vue3";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import IconAngleLeftFilled from "@js/components/Icons/IconAngleLeftFilled.vue";

export default {
    name: "ProductBreadcrumbs",
    components: {
        IconAngleLeftFilled,
        OnlyMobile,
        IconAngleLeft,
        Link,
        OnlyDesktop
    },
    methods: {
        generateLinkParams(key) {
            const params = {
                page: 1
            }

            if (key >= 0) {
                params.base_categories = JSON.stringify([this.productStore.breadcrumbs[0].slug])
            }
            if (key >= 1) {
                params.categories = JSON.stringify([this.productStore.breadcrumbs[1].slug])
            }
            if (key >= 2) {
                params.sub_categories = JSON.stringify([this.productStore.breadcrumbs[2].slug])
            }

            return route('catalog', params);
        },
    },
    computed: {
        displayedBreadcrumbs() {
            const breadcrumbs = this.productStore.breadcrumbs;
            if (!breadcrumbs || breadcrumbs.length === 0) return [];

            if (breadcrumbs.length <= 4) {
                return breadcrumbs;
            }

            return [...breadcrumbs.slice(0, 3), breadcrumbs[breadcrumbs.length - 1]];
        }
    },
    setup() {
        const productStore = useProductStore()

        return {productStore}
    }
}
</script>

<template>
    <nav v-if="productStore.breadcrumbs" class="flex w-full mb-3 text-nowrap overflow-hidden" aria-label="Breadcrumb">
        <ol class="inline-flex items-center justify-start"
            itemscope=""
            itemtype="https://schema.org/BreadcrumbList">
            <OnlyDesktop>
                <li v-for="(breadcrumb, key) in displayedBreadcrumbs"
                    :key="key"
                    class="inline-flex items-center"
                    itemscope=""
                    itemprop="itemListElement"
                    itemtype="https://schema.org/ListItem">
                    <div class="flex items-center justify-start">
                        <IconAngleLeft v-if="key !== 0" class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <Link v-if="key !== Object.keys(productStore.breadcrumbs).length - 1"
                           :href="generateLinkParams(key)"
                           :class="[
                                 key !== Object.keys(productStore.breadcrumbs).length - 1
                                   ? 'hover:text-indigo-600 cursor-pointer'
                                   : 'cursor-default'
                               ]"
                           class="inline-flex items-center text-xs font-bold text-gray-700"
                           itemprop="item">
                            {{ breadcrumb.name }}
                            <meta itemprop="name" :content="breadcrumb.name"/>
                            <meta itemprop="position" :content="key + 1"/>
                        </Link>
                        <span
                            v-else
                            :class="[
                                  key !== Object.keys(productStore.breadcrumbs).length - 1
                                    ? 'hover:text-indigo-600 cursor-pointer'
                                    : 'cursor-default',
                                ]"
                            class="inline-flex items-center text-xs font-bold text-gray-700"
                            itemprop="item">
                        {{ breadcrumb.name }}
                        <meta itemprop="name" :content="breadcrumb.name"/>
                        <meta itemprop="position" :content="key + 1"/>
                    </span>
                    </div>
                </li>
            </OnlyDesktop>
            <OnlyMobile>
                <li class="flex items-center"
                    itemscope=""
                    itemprop="itemListElement"
                    itemtype="https://schema.org/ListItem">
                    <IconAngleLeftFilled/>
                    <Link :href="route('catalog')"
                          class="inline-flex items-center text-sm font-bold hover:text-indigo-600 text-gray-700"
                          itemprop="item">
                        К каталогу
                        <meta itemprop="name" content="К каталогу"/>
                        <meta itemprop="position" content="1"/>
                    </Link>
                </li>
            </OnlyMobile>
        </ol>
    </nav>
</template>

<style scoped lang="scss">

</style>
